import React, { useCallback, useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import UploadIcon from "assets/img/upload.png";
import { Box, Button, Flex, Grid, Label, Text, Image, Toastify } from "atoms";
import { usePropsoch } from "contexts/Propsoch";
import { useParams } from "react-router-dom";
import { uploadFile, verifyUploadFileExcelExtension } from "utils/utilities";
import MemoDownload from "assets/icons/Download";
import MemoExcel from "assets/icons/Excel";
import { format } from "date-fns";
import { PLOT, VILLA } from "utils/constants";

const validationSchema = Yup.object().shape({});
export const UnitDetailForm = ({
  onNext,
  onPrevious,
  bindHitOnSave,
  fetchProperty,
  rootProperty,
}) => {
  const {
    actions: {
      getPropertyListingTowerUnitDetails,
      createPropertyListingTowerUnitDetails,
      createPropertyListingTowerUnitDetailsUploadTower,
      getPropertyListingTowerUnitDetailsUploadTower,
    },
  } = usePropsoch();

  const { id } = useParams();

  // fetch property
  const [property, setProperty] = useState(null);
  const [unitPlanUploads, setUnitPlanUploads] = useState({});

  useEffect(() => {
    id &&
      getPropertyListingTowerUnitDetails(id)?.then((data) => {
        setProperty(data);
      });
    id &&
      getPropertyListingTowerUnitDetailsUploadTower(id)?.then((data) => {
        let uploadUrls = {};
        if (
          rootProperty?.types?.[0]?.name?.toLowerCase()?.includes(PLOT) ||
          rootProperty?.types?.[0]?.name?.toLowerCase()?.includes(VILLA)
        ) {
          uploadUrls = data;
        } else {
          data?.forEach((i) => {
            uploadUrls[i?.detail?.towerName] = i?.detail;
          });
        }
        setUnitPlanUploads(uploadUrls);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // file upload handler
  const [uploading, setUploading] = useState(false);
  const onFileUploadHandler = useCallback(
    async (e, towerName) => {
      setUploading({ name: towerName });
      const file = e?.target?.files?.[0];

      if (verifyUploadFileExcelExtension(file)) {
        try {
          const { location } = await uploadFile(file);
          await createPropertyListingTowerUnitDetails(
            {
              propertyId: id,
              towerName,
              file,
            },
            rootProperty?.name
          );
          await createPropertyListingTowerUnitDetailsUploadTower({
            propertyId: id,
            towerName,
            url: location,
          });
          setUploading((prev) => ({
            ...prev,
          }));
          Toastify("success", "Uploaded successfully");
        } catch (e) {
          setUploading((prev) => ({ ...prev, error: e?.message || e }));
          Toastify("error", "Failed to upload", e?.message || "");
        } finally {
          setUploading(false);
          id &&
            getPropertyListingTowerUnitDetails(id)?.then((data) => {
              setProperty(data);
            });
          id &&
            getPropertyListingTowerUnitDetailsUploadTower(id)?.then((data) => {
              let uploadUrls = {};
              if (
                rootProperty?.types?.[0]?.name?.toLowerCase()?.includes(PLOT) ||
                rootProperty?.types?.[0]?.name?.toLowerCase()?.includes(VILLA)
              ) {
                uploadUrls = data;
              } else {
                data?.forEach((i) => {
                  uploadUrls[i?.detail?.towerName] = i?.detail;
                });
              }
              setUnitPlanUploads(uploadUrls);
            });
        }
      } else {
        console.log(".xlsx format only");
      }
    },
    [
      id,
      createPropertyListingTowerUnitDetails,
      rootProperty,
      createPropertyListingTowerUnitDetailsUploadTower,
      getPropertyListingTowerUnitDetails,
      getPropertyListingTowerUnitDetailsUploadTower,
    ]
  );

  return (
    <Formik
      initialValues={{}}
      onSubmit={() => onNext()}
      validationSchema={validationSchema}
    >
      {({ submitForm }) => {
        bindHitOnSave(() => {
          submitForm();
        });
        return (
          <Form>
            <Grid gridGap="3.2rem" mt="2.4rem">
              {property?.propertyType?.includes(PLOT) && (
                <Grid gridGap="2.4rem">
                  <Label text={`Plots : Upload Excel sheet`} />
                  <Box
                    border="1px dashed"
                    borderColor="neutral.400"
                    p="2.4rem"
                    borderRadius="1rem"
                  >
                    <Flex justifyContent="space-between" alignItems="center">
                      <Grid gridAutoFlow="column" gridGap="2rem">
                        <Image
                          src={UploadIcon}
                          objectfit="contain"
                          width="5rem"
                        />
                        <Box>
                          <Text
                            color="Black"
                            mb="1rem"
                            fontFamily="NeometricRegular"
                          >
                            Select file
                          </Text>
                          <Text
                            color="neutral.400"
                            fontSize="1.4rem"
                            fontFamily="NeometricRegular"
                          >
                            XLS file size no more than 10MB
                          </Text>
                        </Box>
                      </Grid>
                      <Button
                        variant="primaryOutline"
                        height="4.3rem"
                        width="fit-content"
                        px="3rem"
                        type="button"
                        as="label"
                        loading={uploading?.name === "Plots"}
                      >
                        <input
                          name="logo"
                          type="file"
                          noMargin
                          disabled={uploading}
                          style={{ display: "none" }}
                          onChange={(e) => onFileUploadHandler(e, "Plots")}
                          accept=".xlsx"
                          multiple
                        />
                        {property?.unitPlanArray ? "Re-upload" : "Upload"}
                      </Button>
                    </Flex>
                  </Box>
                  {unitPlanUploads && (
                    <Box>
                      <Text fontSize="1.4rem" color="neutral.800" pt="1.6rem">
                        Files added
                      </Text>

                      <Grid
                        p="3rem"
                        gridTemplateColumns="repeat(4, 1fr)"
                        gridGap="1.6rem"
                      >
                        <Box>
                          <>
                            <Flex
                              bg="primary.900"
                              color="white"
                              w="fit-content"
                              py="0.74rem"
                              px="0.72rem"
                              aI="center"
                              borderRadius="100%"
                              position="absolute"
                              top="1.3rem"
                              right="1.3rem"
                              cursor="pointer"
                              zIndex={1}
                              onClick={() => {
                                window.open(unitPlanUploads?.url);
                              }}
                            >
                              <MemoDownload />
                            </Flex>
                            <Flex
                              width="16rem"
                              height="16rem"
                              minHeight="16rem"
                              minWidth="16rem"
                              borderRadius="1rem"
                              bg="secondary.50"
                              alignItems="flex-start"
                              justifyContent="flex-end"
                              px="1.76rem"
                              py="1.6rem"
                              flexDirection="column"
                            >
                              <Box color="secondary.500" height="min-content">
                                <MemoExcel />
                              </Box>
                              <Text
                                mt="0.8rem"
                                color="neutral.400"
                                fontSize="1.4rem"
                                fontFamily="NeometricRegular"
                              >
                                Uploaded on
                              </Text>
                              <Text
                                mt="0.4rem"
                                color="neutral.400"
                                fontSize="1.4rem"
                                fontFamily="NeometricRegular"
                              >
                                {unitPlanUploads?.createdAt &&
                                  format(
                                    new Date(unitPlanUploads?.createdAt),
                                    "dd-MM-yyyy"
                                  )}
                              </Text>
                            </Flex>
                          </>
                        </Box>
                      </Grid>
                    </Box>
                  )}
                </Grid>
              )}
              {property?.propertyType?.includes(VILLA) && (
                <Grid gridGap="2.4rem">
                  <Label text={`Villa : Upload Excel sheet`} />
                  <Box
                    border="1px dashed"
                    borderColor="neutral.400"
                    p="2.4rem"
                    borderRadius="1rem"
                  >
                    <Flex justifyContent="space-between" alignItems="center">
                      <Grid gridAutoFlow="column" gridGap="2rem">
                        <Image
                          src={UploadIcon}
                          objectfit="contain"
                          width="5rem"
                        />
                        <Box>
                          <Text
                            color="Black"
                            mb="1rem"
                            fontFamily="NeometricRegular"
                          >
                            Select file
                          </Text>
                          <Text
                            color="neutral.400"
                            fontSize="1.4rem"
                            fontFamily="NeometricRegular"
                          >
                            XLS file size no more than 10MB
                          </Text>
                        </Box>
                      </Grid>
                      <Button
                        variant="primaryOutline"
                        height="4.3rem"
                        width="fit-content"
                        px="3rem"
                        type="button"
                        as="label"
                        loading={uploading?.name === "villa"}
                      >
                        <input
                          name="logo"
                          type="file"
                          noMargin
                          disabled={uploading}
                          style={{ display: "none" }}
                          onChange={(e) => onFileUploadHandler(e, "villa")}
                          accept=".xlsx"
                          multiple
                        />
                        {property?.unitPlanArray ? "Re-upload" : "Upload"}
                      </Button>
                    </Flex>
                  </Box>
                  {unitPlanUploads && (
                    <Box>
                      <Text fontSize="1.4rem" color="neutral.800" pt="1.6rem">
                        Files added
                      </Text>

                      <Grid
                        p="3rem"
                        gridTemplateColumns="repeat(4, 1fr)"
                        gridGap="1.6rem"
                      >
                        <Box>
                          <>
                            <Flex
                              bg="primary.900"
                              color="white"
                              w="fit-content"
                              py="0.74rem"
                              px="0.72rem"
                              aI="center"
                              borderRadius="100%"
                              position="absolute"
                              top="1.3rem"
                              right="1.3rem"
                              cursor="pointer"
                              zIndex={1}
                              onClick={() => {
                                window.open(unitPlanUploads?.url);
                              }}
                            >
                              <MemoDownload />
                            </Flex>
                            <Flex
                              width="16rem"
                              height="16rem"
                              minHeight="16rem"
                              minWidth="16rem"
                              borderRadius="1rem"
                              bg="secondary.50"
                              alignItems="flex-start"
                              justifyContent="flex-end"
                              px="1.76rem"
                              py="1.6rem"
                              flexDirection="column"
                            >
                              <Box color="secondary.500" height="min-content">
                                <MemoExcel />
                              </Box>
                              <Text
                                mt="0.8rem"
                                color="neutral.400"
                                fontSize="1.4rem"
                                fontFamily="NeometricRegular"
                              >
                                Uploaded on
                              </Text>
                              <Text
                                mt="0.4rem"
                                color="neutral.400"
                                fontSize="1.4rem"
                                fontFamily="NeometricRegular"
                              >
                                {unitPlanUploads?.createdAt &&
                                  format(
                                    new Date(unitPlanUploads?.createdAt),
                                    "dd-MM-yyyy"
                                  )}
                              </Text>
                            </Flex>
                          </>
                        </Box>
                      </Grid>
                    </Box>
                  )}
                </Grid>
              )}
              {!property?.propertyType?.includes(PLOT) &&
                !property?.propertyType?.includes(VILLA) &&
                property?.map((tower, index) => (
                  <Grid gridGap="2.4rem" key={index}>
                    <Label text={`${tower?.towerName} : Upload Excel sheet`} />
                    <Box
                      border="1px dashed"
                      borderColor="neutral.400"
                      p="2.4rem"
                      borderRadius="1rem"
                    >
                      <Flex justifyContent="space-between" alignItems="center">
                        <Grid gridAutoFlow="column" gridGap="2rem">
                          <Image
                            src={UploadIcon}
                            objectfit="contain"
                            width="5rem"
                          />
                          <Box>
                            <Text
                              color="Black"
                              mb="1rem"
                              fontFamily="NeometricRegular"
                            >
                              Select file
                            </Text>
                            <Text
                              color="neutral.400"
                              fontSize="1.4rem"
                              fontFamily="NeometricRegular"
                            >
                              XLS file size no more than 10MB
                            </Text>
                          </Box>
                        </Grid>
                        <Button
                          variant="primaryOutline"
                          height="4.3rem"
                          width="fit-content"
                          px="3rem"
                          type="button"
                          as="label"
                          loading={uploading?.name === tower?.towerName}
                        >
                          <input
                            name="logo"
                            type="file"
                            noMargin
                            disabled={uploading}
                            style={{ display: "none" }}
                            onChange={(e) =>
                              onFileUploadHandler(e, tower?.towerName)
                            }
                            accept=".xlsx"
                            multiple
                          />
                          {tower?.towerUnitPlanArray ? "Re-upload" : "Upload"}
                        </Button>
                        {/* {!tower?.towerUnitPlanArray ? (
                          <Button
                            variant="primaryOutline"
                            height="4.3rem"
                            width="fit-content"
                            px="3rem"
                            type="button"
                            as="label"
                            loading={uploading?.name === tower?.towerName}
                          >
                            <input
                              name="logo"
                              type="file"
                              noMargin
                              disabled={uploading}
                              style={{ display: "none" }}
                              onChange={(e) =>
                                onFileUploadHandler(e, tower?.towerName)
                              }
                              accept=".xlsx"
                              multiple
                            />
                            Select File
                          </Button>
                        ) : (
                          <Box color="accents.200">
                            <MemoTickIcon />
                          </Box>
                        )} */}
                      </Flex>
                    </Box>
                    {unitPlanUploads?.[`${tower?.towerName}`] && (
                      <Box>
                        <Text fontSize="1.4rem" color="neutral.800" pt="1.6rem">
                          Files added
                        </Text>

                        <Grid
                          p="3rem"
                          gridTemplateColumns="repeat(4, 1fr)"
                          gridGap="1.6rem"
                        >
                          <Box>
                            <>
                              <Flex
                                bg="primary.900"
                                color="white"
                                w="fit-content"
                                py="0.74rem"
                                px="0.72rem"
                                aI="center"
                                borderRadius="100%"
                                position="absolute"
                                top="1.3rem"
                                right="1.3rem"
                                cursor="pointer"
                                zIndex={1}
                                onClick={() => {
                                  window.open(
                                    unitPlanUploads?.[`${tower?.towerName}`]
                                      ?.url
                                  );
                                }}
                              >
                                <MemoDownload />
                              </Flex>
                              <Flex
                                width="16rem"
                                height="16rem"
                                minHeight="16rem"
                                minWidth="16rem"
                                borderRadius="1rem"
                                bg="secondary.50"
                                alignItems="flex-start"
                                justifyContent="flex-end"
                                px="1.76rem"
                                py="1.6rem"
                                flexDirection="column"
                              >
                                <Box color="secondary.500" height="min-content">
                                  <MemoExcel />
                                </Box>
                                <Text
                                  mt="0.8rem"
                                  color="neutral.400"
                                  fontSize="1.4rem"
                                  fontFamily="NeometricRegular"
                                >
                                  Uploaded on
                                </Text>
                                <Text
                                  mt="0.4rem"
                                  color="neutral.400"
                                  fontSize="1.4rem"
                                  fontFamily="NeometricRegular"
                                >
                                  {unitPlanUploads?.[`${tower?.towerName}`]
                                    ?.createdAt &&
                                    format(
                                      new Date(
                                        unitPlanUploads?.[
                                          `${tower?.towerName}`
                                        ]?.createdAt
                                      ),
                                      "dd-MM-yyyy"
                                    )}
                                </Text>
                              </Flex>
                            </>
                          </Box>
                        </Grid>
                      </Box>
                    )}
                  </Grid>
                ))}

              <Flex my="2rem" gridGap="1.6rem">
                <Button
                  px="3rem"
                  width="fit-content"
                  variant="primaryOutline"
                  height="4.8rem"
                  onClick={onPrevious}
                >
                  Previous
                </Button>
                <Button
                  px="3rem"
                  width="fit-content"
                  variant="primary"
                  height="4.8rem"
                  type="submit"
                >
                  Next
                </Button>
              </Flex>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};
